import { get } from "lodash";
import { useTranslation } from "react-i18next";
import Card from "shared/components/Card";
import Radio from "shared/components/Form/Radio";
import Input from "shared/components/Input";
import Switch from "shared/components/Input/Switch";
import { NAME_SPACES } from "shared/locales/constants";
import { GENDER } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";
import SkillGroups from "../../shared/SkillGroups";

const Default = ({ formProps }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.BROKER);
  const FORM = t("FORM", { returnObjects: true });

  return (
    <div className="grid--1">
      <Card key="user" type={"simple"} head title={FORM.LEGAL_INFO}>
        <div className="grid--2">
          <Radio
            isHorizontal={false}
            label={FORM.CIVILITY.LABEL}
            options={[
              {
                label: FORM.CIVILITY.MALE,
                value: GENDER.MALE,
              },
              {
                label: FORM.CIVILITY.FEMALE,
                value: GENDER.FEMALE,
              },
            ]}
            {...bindInputProps({ name: "gender", ...formProps })}
            required
          />
          <div />
          <Input
            placeholder={FORM.FIRST_NAME}
            label={FORM.FIRST_NAME}
            {...bindInputProps({ name: "firstname", ...formProps })}
          />
          <Input
            placeholder={FORM.LAST_NAME}
            label={FORM.LAST_NAME}
            {...bindInputProps({ name: "lastname", ...formProps })}
          />
          <Input
            placeholder={FORM.PHONE}
            label={FORM.PHONE}
            {...bindInputProps({ name: "phone", ...formProps })}
          />
          <Input
            placeholder={FORM.EMAIL}
            label={FORM.EMAIL}
            {...bindInputProps({ name: "email", ...formProps })}
          />

          <Switch
            label="External Distribution Partnership"
            checkedChildren={FORM.OPTIONS.YES}
            unCheckedChildren={FORM.OPTIONS.NO}
            defaultChecked={get(
              formProps.values,
              "params.extDistPartner",
              false,
            )}
            onChange={(e) =>
              formProps.setFieldValue("params.extDistPartner", e)
            }
          />
        </div>
      </Card>
      <div key="div-2" className="m-bottom-20" />
      <SkillGroups formProps={formProps} FORM={FORM} />
    </div>
  );
};

export default Default;
